import { BaseDynamicElementScriptRenderer } from "../../../shared/rendering/base-dynamic-element-script-renderer";
import {
    WidgetScriptContentProvider
} from "../../../shared/rendering/local-script-content-providers/widget-script-content-provider";

export class TextScriptRenderer extends BaseDynamicElementScriptRenderer {

    constructor() {
        super(
            "0.1",
            "pb-text-script",
            "/common/scripts/text-widget.js",
            "text",
            new WidgetScriptContentProvider("TextWidget")
        );
    }

}
